import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@mui/material';

interface CenterPointDialogProps {
  open: boolean;
  onClose: () => void;
  handleSubmit: (lat: number, lng: number) => void;
}

const CenterPointDialog: React.FC<CenterPointDialogProps> = ({ open, onClose, handleSubmit }) => {
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');

  const handleDialogSubmit = () => {
    handleSubmit(parseFloat(lat), parseFloat(lng));
    setLat('');
    setLng('');
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Set Center Point</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Latitude"
          type="number"
          fullWidth
          value={lat}
          onChange={(e) => setLat(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          margin="dense"
          label="Longitude"
          type="number"
          fullWidth
          value={lng}
          onChange={(e) => setLng(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleDialogSubmit} variant="contained">Set</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CenterPointDialog; 